__turbopack_context__.v({
  "content": "MainLayout-module-scss-module__3souLa__content",
  "drawerOpen": "MainLayout-module-scss-module__3souLa__drawerOpen",
  "oneScreen": "MainLayout-module-scss-module__3souLa__oneScreen",
  "railVisible": "MainLayout-module-scss-module__3souLa__railVisible",
});
